import React, { FC } from 'react';
import { CodeIcon } from './icons/icons';
import { HeroSection } from './components/hero';
import { Footer } from './components/footer';
import ContactSection from './components/contactUs';
import { ServicesSection } from './components/services';
import { Nav } from './components/nav';


// Interface for Project data
interface Project {
    title: string;
    description: string;
    tags: string[];
}


const ProjectCard: FC<{ project: Project }> = ({ project }) => (
  <div className="inline-block max-w-xs w-72 mx-4 p-6 bg-white border border-gray-100 rounded-2xl shadow-xl flex-shrink-0 snap-center transition-transform duration-300 hover:scale-[1.03] hover:shadow-2xl">
    <CodeIcon className="w-8 h-8 text-teal-600 mb-3" />
    <h4 className="text-xl font-bold text-gray-900 mb-2 whitespace-normal">{project.title}</h4>
    <p className="text-gray-500 text-sm mb-4 whitespace-normal">{project.description}</p>
    <div className="flex flex-wrap gap-2">
      {project.tags.map((tag: string) => (
        <span key={tag} className="px-3 py-1 text-xs font-semibold bg-orange-100 text-orange-700 rounded-full">
          {tag}
        </span>
      ))}
    </div>
  </div>
);

const ProjectsSection = () => {
  const projects: Project[] = [
    { title: "Lottery Ticket Scanner", description: "A web application to scan Lottery tickets and extract numbers onto a downloadable PDF", tags: ["React", "Python", "FastAPI", "GitHub Actions", "Docker"] },
    { title: "Rentshare", description: "An application to allow users to find places to sublet", tags: ["React", "Flutter", "Firebase", "Typescript", "GitHub Actions", "Docker"] },
    { title: "BuyBuddy", description: "An application to allow users to compare product prices", tags: ["Angular", "UX/UI", "Optimization", "Cloud Functions"] },
  ];

  return (
    <section id="projects" className="py-16 md:py-20 bg-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 text-center mb-4">
          Projects Completed
        </h2>
        <p className="text-lg md:text-xl text-gray-600 text-center mb-10 md:mb-12">
          A few examples of our recent client success stories.
        </p>
      </div>

      {/* Horizontal Scrolling Carousel - uses flex-shrink-0 and snap-x for smooth scrolling on touch devices */}
      <div className="overflow-x-scroll flex pb-6 scrollbar-hide snap-x snap-mandatory">
        <div className="flex px-4 md:px-6 lg:px-8">
          {projects.map((project: Project, index: number) => (
            <ProjectCard key={index} project={project} />
          ))}
          {/* Add a blank card for padding at the end */}
          <div className="w-4 md:w-6 lg:w-8 flex-shrink-0"></div>
        </div>
      </div>
      
      {/* Custom Scrollbar Styling */}
      <style>{`
        /* Hide scrollbar for Chrome, Safari and Opera */
        .scrollbar-hide::-webkit-scrollbar {
            display: none;
        }
        /* Hide scrollbar for IE, Edge and Firefox */
        .scrollbar-hide {
            -ms-overflow-style: none;  /* IE and Edge */
            scrollbar-width: none;  /* Firefox */
        }
      `}</style>
    </section>
  );
};


const App = () => {
 

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Nav />
      <main>
        <HeroSection />
        <ServicesSection />
        <ProjectsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;
